import type { AuthError } from "@supabase/supabase-js";
import { createContext, useContext } from "react";

interface AuthContext {
  signIn: ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }) => Promise<boolean | AuthError>;
  signOut: () => void;
}

export const AuthContext = createContext<AuthContext | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error(
      "useAuth must be used within a AuthProvider, but no provider was found",
    );
  }

  return context;
};
